var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	83101: () => (loadSingletonVersion("default", "@angular/compiler", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_compiler_fesm2022_compiler_mjs").then(() => (() => (__webpack_require__(/*! @angular/compiler */ 45568))))))),
	21299: () => (loadSingletonVersion("default", "@angular/animations", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_animations_mjs-_d6a80").then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	94295: () => (loadSingletonVersion("default", "@angular/core", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	16361: () => (loadSingletonVersion("default", "@angular/common", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4620").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	55883: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	76883: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	52713: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	46345: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_di_mjs").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))))),
	20425: () => (loadSingletonVersion("default", "@angular/core/primitives/event-dispatch", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_event-dispatch_mjs").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/event-dispatch */ 56745))))))),
	75189: () => (loadSingletonVersion("default", "@angular/common/http", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9340").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	90184: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	59343: () => (loadSingletonVersion("default", "@angular/cdk/a11y", false, [1,19,2,6], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	44963: () => (loadSingletonVersion("default", "@angular/cdk/bidi", false, [1,19,2,6], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	24095: () => (loadSingletonVersion("default", "@angular/cdk/platform", false, [1,19,2,6], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_platform_mjs-_90951").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	32617: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_2a590").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	80127: () => (loadSingletonVersion("default", "@auth0/auth0-angular", false, [1,2,2,3], () => (__webpack_require__.e("node_modules_auth0_auth0-angular_fesm2020_auth0-auth0-angular_mjs-_08061").then(() => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 5923))))))),
	14437: () => (loadSingletonVersion("default", "@angular/router", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	99029: () => (loadSingletonVersion("default", "date-fns", false, [1,2,28,0], () => (__webpack_require__.e("node_modules_date-fns_esm_index_js").then(() => (() => (__webpack_require__(/*! date-fns */ 21097))))))),
	62410: () => (loadSingletonVersion("default", "@cds/angular/shared", false, [2,0,13,5], () => (__webpack_require__.e("node_modules_cds_angular_fesm2020_cds-angular-shared_mjs-_29501").then(() => (() => (__webpack_require__(/*! @cds/angular/shared */ 70293))))))),
	25811: () => (loadSingletonVersion("default", "@angular/forms", false, [1,19,2,2], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456)))))))
};
var initialConsumes = [83101];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"polyfills": [
		83101
	],
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a591": [
		21299,
		94295
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a81": [
		16361,
		94295
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca010": [
		16361,
		55883,
		76883,
		94295
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d90": [
		16361,
		94295
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90950": [
		16361,
		94295
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		16361,
		55883,
		76883,
		94295
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		55883,
		94295
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		52713,
		46345,
		55883,
		20425,
		76883
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		16361,
		55883,
		76883,
		94295
	],
	"node_modules_angular_material_fesm2022_icon_mjs-_bb191": [
		94295,
		16361,
		55883,
		76883,
		75189,
		90184,
		59343,
		44963
	],
	"node_modules_angular_material_fesm2022_toolbar_mjs-_25671": [
		94295,
		24095,
		16361,
		59343,
		44963
	],
	"node_modules_angular_platform-browser-dynamic_fesm2022_platform-browser-dynamic_mjs-_eaf01": [
		94295,
		83101,
		16361,
		90184
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a1": [
		94295,
		90184,
		32617,
		16361
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		16361,
		75189,
		94295
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		16361,
		55883,
		76883,
		90184,
		94295
	],
	"node_modules_auth_auth_fesm2022_auth-auth_mjs-_48771": [
		94295,
		80127,
		75189,
		55883,
		76883
	],
	"node_modules_auth0_auth0-angular_fesm2020_auth0-auth0-angular_mjs-_08060": [
		14437,
		16361,
		55883,
		76883,
		94295
	],
	"node_modules_cds_angular_fesm2020_cds-angular-shared_mjs-_29500": [
		55883,
		76883,
		94295,
		99029
	],
	"node_modules_cds_angular_fesm2020_cds-angular_mjs-_a68c1": [
		16361,
		94295,
		59343,
		55883,
		76883,
		62410,
		14437,
		25811,
		99029
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a80": [
		16361
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		55883
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		75189
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		16361,
		55883,
		76883
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011": [
		55883,
		76883
	],
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a590": [
		21299
	],
	"node_modules_auth0_auth0-angular_fesm2020_auth0-auth0-angular_mjs-_08061": [
		14437,
		16361,
		76883
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		76883,
		90184
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}